<template>
  <div class="container-fluid message-container-align">
    <h2>{{ t("form.invalidrequest") }}</h2>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
<style scoped>
.message-container-align {
  min-height: 363px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
  